// app\javascript\dashboard\routes\index.js

import { createRouter, createWebHistory } from 'vue-router';

import { frontendURL } from '../helper/URLHelper';
import dashboard from './dashboard/dashboard.routes';
import store from 'dashboard/store';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import AnalyticsHelper from '../helper/AnalyticsHelper';
import GoogleAnalyticsHelper from '../helper/GoogleAnalyticsHelper';
import { buildPermissionsFromRouter } from '../helper/permissionsHelper';

const routes = [...dashboard.routes];

export const router = createRouter({ history: createWebHistory(), routes });
export const routesWithPermissions = buildPermissionsFromRouter(routes);

export const validateAuthenticateRoutePermission = (to, next) => {
  const { isLoggedIn, getCurrentUser: user } = store.getters;

  if (!isLoggedIn) {
    window.location.assign('/app/login');
    return '';
  }

  // SuperAdmin não precisa aceitar contrato
  const isSuperAdmin = user?.type === 'SuperAdmin';
  const isContractPage = to.path?.includes('/auth/contract');

  if (isSuperAdmin) {
    // Se SuperAdmin está tentando acessar a página de contrato, redirecionar
    if (isContractPage) {
      // Se tem account_id, redirecionar para dashboard, senão para super_admin
      if (user.account_id) {
        return next(frontendURL(`accounts/${user.account_id}/dashboard`));
      }
      window.location.assign('/super_admin');
      return '';
    }

    // Continuar navegação normal para SuperAdmin
    if (!to.name) {
      if (user.account_id) {
        return next(frontendURL(`accounts/${user.account_id}/dashboard`));
      }
      window.location.assign('/super_admin');
      return '';
    }

    const nextRoute = validateLoggedInRoutes(to, store.getters.getCurrentUser);
    return nextRoute ? next(frontendURL(nextRoute)) : next();
  }

  // Contrato desabilitado: nunca forçar a página de contrato.
  if (isContractPage) {
    return next(frontendURL(`accounts/${user.account_id}/dashboard`));
  }

  // ========== VERIFICACAO DE TRIAL (DESABILITADA) ==========
  // A verificação de trial foi desabilitada. O controle de assinatura
  // agora é feito através da seção "Sua Assinatura" em Configurações da Conta.
  //
  // const isTrialExpiredPage = to.path?.includes('/auth/trial-expired');
  // const trialEndsAt = userAccount?.custom_attributes?.trial_ends_at;
  // const subscriptionStatus = userAccount?.custom_attributes?.subscription_status;
  // const hasActiveSubscription = subscriptionStatus === 'active';
  //
  // // Se esta na pagina de trial expirado, verificar se deve ficar ou sair
  // if (isTrialExpiredPage) {
  //   // Se tem subscription ativa, redirecionar para dashboard
  //   if (hasActiveSubscription) {
  //     return next(frontendURL(`accounts/${user.account_id}/dashboard`));
  //   }
  //   // Se trial ainda e valido, redirecionar para dashboard
  //   if (trialEndsAt) {
  //     const trialEndDate = new Date(trialEndsAt);
  //     const now = new Date();
  //     if (now <= trialEndDate) {
  //       return next(frontendURL(`accounts/${user.account_id}/dashboard`));
  //     }
  //   }
  //   // Trial expirou e nao tem subscription - deixar na pagina
  //   return next();
  // }
  //
  // // Verificar se trial expirou (apenas se nao tem subscription ativa)
  // if (!hasActiveSubscription && trialEndsAt) {
  //   const trialEndDate = new Date(trialEndsAt);
  //   const now = new Date();
  //
  //   if (now > trialEndDate) {
  //     // Trial expirou - redirecionar para pagina de trial expirado
  //     window.location.assign('/app/auth/trial-expired');
  //     return '';
  //   }
  // }
  // ========== FIM VERIFICACAO DE TRIAL ==========

  if (!to.name) {
    const dashboardUrl = frontendURL(`accounts/${user.account_id}/dashboard`);
    return next(dashboardUrl);
  }

  const nextRoute = validateLoggedInRoutes(to, store.getters.getCurrentUser);
  if (nextRoute) {
    const redirectUrl = frontendURL(nextRoute);
    return next(redirectUrl);
  }
  return next();
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach((to, _from, next) => {
    // Track with existing analytics (June.so)
    AnalyticsHelper.page(to.name || '', {
      path: to.path,
      name: to.name,
    });

    // Track with Google Analytics (Firebase)
    GoogleAnalyticsHelper.trackPageView(to.path, to.name || 'Unknown Page', {
      account_id: store.getters.getCurrentAccountId,
      user_id: store.getters.getCurrentUser?.id
    });

    userAuthentication.then(() => {
      return validateAuthenticateRoutePermission(to, next, store);
    });
  });
};

export default router;
